const tooltipMoneyBuilderText="This level of the money builder has not been unlocked... yet.";
export default tooltipMoneyBuilderText;